import { AskAIChatbot } from "@root/components/AskAIChatbot/ChatBot";
import { AskAIChatbotChatScreen } from "@root/components/AskAIChatbot/ChatBotChatScreen";
import { MultiAskAIPage } from "@root/pages/multi-ask-ai";
import { LegalCompliancePage } from "@root/pages/legal-compliance";
import { ROUTE_NAMES } from "@root/constants";
import { CountryProvider } from "@root/context";
import { GlobalContextProvider } from "@root/context/global-context";
import { KPSChatProvider } from "@root/context/kps-chat-context";
import { DashboardProvider } from "@root/context/kps-dashboard-context";
import DashboardLayout from "@root/layouts/DashboardLayout";
import OpenLayout from "@root/layouts/OpenLayout";
import { MainChatContainer } from "@root/pages/dashboard/components/mainChat";
import { UserProjectsDashboard } from "@root/pages/dashboard/projectsDashboard";
import { DashboardPage } from "@root/pages/dashboardpage/dashboard";
import { RiskAssessmentDetailPage } from "@root/pages/risk-assessment-detail";
import { RiskAssessmentPage } from "@root/pages/risk-assessment";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { RiskAssessmentContextProvider } from "@root/context/risk-assessment-context";
import { DepartmentContextProvider } from "@root/context/department-contxt";
import { EquipmentContextProvider } from "@root/context/euqipment-context";
import { MaterialContextProvider } from "@root/context/material-context";

export const protectedRoutes = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to={ROUTE_NAMES.RISK_ASSESSMENT} />,
  },

  {
    path: "/",
    element: <OpenLayout />,
    children: [
      {
        path: ROUTE_NAMES.SHARED_THREAD,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.SHARED_CHAT,
        element: <MainChatContainer />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <GlobalContextProvider>
        <DashboardProvider>
          <KPSChatProvider>
            <CountryProvider>
              <RiskAssessmentContextProvider>
                <DepartmentContextProvider>
                  <EquipmentContextProvider>
                    <MaterialContextProvider>
                      <DashboardLayout />
                    </MaterialContextProvider>
                  </EquipmentContextProvider>
                </DepartmentContextProvider>
              </RiskAssessmentContextProvider>
            </CountryProvider>
          </KPSChatProvider>
        </DashboardProvider>
      </GlobalContextProvider>
    ),
    children: [
      {
        path: ROUTE_NAMES.DASHBOARD,
        element: <DashboardPage />,
        // element: <DashboardPage />,
      },
      {
        path: ROUTE_NAMES.ASK_AI_CHATBOT,
        element: <AskAIChatbot />,
      },
      {
        path: ROUTE_NAMES.ASK_AI_CHATBOT,
        element: <AskAIChatbotChatScreen />,
      },
      {
        path: ROUTE_NAMES.ASK_AI_CHATBOT_CHAT,
        element: <AskAIChatbotChatScreen />,
      },
      {
        path: ROUTE_NAMES.ASK_AI_CHATBOT_CHAT_BY_ID,
        element: <AskAIChatbotChatScreen />,
      },
      {
        path: ROUTE_NAMES.MULTI_AI_CHATBOT,
        element: <MultiAskAIPage />,
      },
      {
        path: ROUTE_NAMES.RISK_ASSESSMENT,
        element: <RiskAssessmentPage />,
      },
      {
        path: ROUTE_NAMES.RISK_ASSESSMENT_DETAIL,
        element: <RiskAssessmentDetailPage />,
      },
      {
        path: ROUTE_NAMES.LEGAL_COMPLIANCE,
        element: <LegalCompliancePage />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={ROUTE_NAMES.RISK_ASSESSMENT} />,
  },
]);
